import React from 'react';

export default () => (
  <React.Fragment>
    Køleanlæg samt kulsyre der passer til dit behov medfølger.
  </React.Fragment>
);
